import WorkflowToken from '@apps/automation/admin/tokens/workflow'
import New from '@apps/automation/admin/views/workflows/new'
import Panel from '@admin/components/panel'
import React from 'react'

export const triggers = [
  { id: 60, code: 'maha:affiliate_created' },
  { id: 56, code: 'maha:payout_issued' },
  { id: 57, code: 'maha:referral_team_created' },
  { id: 61, code: 'maha:referral_trial_started' },
  { id: 58, code: 'maha:referral_trial_ended' },
  { id: 59, code: 'maha:referral_subscription_canceled' },
  { id: 62, code: 'maha:signup_cart_duration' },
  { id: 35, code: 'maha:signup_created' },
  { id: 46, code: 'maha:team_status_duration' },
  { id: 47, code: 'maha:team_status_transitioned' },
  { id: 42, code: 'truevail:demo_scheduled' },
  { id: 43, code: 'truevail:demo_rescheduled' },
  { id: 44, code: 'truevail:demo_canceled' },
  { id: 45, code: 'truevail:demo_completed' },
  { id: 55, code: 'truevail:demo_noshowed' },
  { id: 49, code: 'truevail:demo_converted' },
  { id: 50, code: 'truevail:participant_registered' },
  { id: 53, code: 'truevail:participant_noshowed' },
  { id: 52, code: 'truevail:participant_attended' },
  { id: 54, code: 'truevail:participant_completed' },
  { id: 51, code: 'truevail:participant_converted' }
]

const getNew = (props, context) => ({
  program_id: context.admin.programs[0].id,
  triggers: triggers.map(trigger => trigger.code )
})

const mapPropsToPanel = (props, context) => ({
  title: 't(ty(Workflows))',
  collection: {
    endpoint: '/api/admin/automation/workflows',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true, format: (workflow) => (
        <WorkflowToken workflow={ workflow } compact={ true } />
      ) }
    ],
    empty: {
      title: 't(No Workflows)',
      text: 't(There are no workflows for this email campaign)',
      svg: 'network',
      buttons: [
        { 
          label: 't(Create Workflow)',
          access: {
            rights: { $allOf: ['automation:access_app','automation:manage_workflows'] }
          },
          modal: <New { ...getNew(props, context) } /> 
        }
      ]
    },
    export: [
      { label: 't(ID)', key: 'id' },
      { label: 't(Title)', key: 'display_name' },
      { label: 't(Program)', key: 'program.title' },
      { label: 't(Enrolled)', key: 'enrolled_count' },
      { label: 't(Active)', key: 'active_count' },
      { label: 't(Lost)', key: 'lost_count' },
      { label: 't(Converted)', key: 'converted_count' },
      { label: 't(Completed)', key: 'completed_count' },
      { label: 't(Status)', key: 'status' }
    ],
    entity: 'worfklow',
    defaultQuery: { trigger_ids: triggers.map(trigger => trigger.id) },
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => context.router.push(`/automation/workflows/${record.id}`)
  },
  task: {
    svg: 'plus',
    access: {
      rights: { $allOf: ['automation:access_app','automation:manage_workflows'] }
    },
    modal: <New { ...getNew(props, context) } />
  }
})

export default Panel(null, mapPropsToPanel)
